import { stringDate } from "../utils/utilityFunctions";
import { showGlobalDialogError } from "../components/error";
import { apiClient } from "./apiClient.services";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const GetTransfers = async (startDate, endDate) => {
	const { businessId } = getAuthData();
	const datetostring = stringDate([startDate, endDate]);

	if (datetostring[0] === 'Invalid date') {
		datetostring[0] = datetostring[1]
	}

	if (datetostring[1] === 'Invalid date') {
		datetostring[1] = datetostring[0]
	}
	try {
        let params = new URLSearchParams();
        params.append("startDate", datetostring[0]);
        params.append("endDate", datetostring[1]);
        if (localStorage.getItem("businessId")) params.append("businessId", businessId);

		return await apiClient(`/transactions/transfers?${params.toString()}`);
	} catch (e) {
		showGlobalDialogError();
	}
}

export const PostWithdraw = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/core/withdraw${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`, {
			method: "POST",
			body: value
		});
	} catch (e) {
		throw e;
	}
}

export const GetWithdraw = async (value) => {
	const { businessId } = getAuthData();

	try {
		return await apiClient(`/core/withdraw${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
	}
}
